import React from "react";
import Tooltip from "material-ui/Tooltip";
import Place from "material-ui-icons/Place";
import { assets } from "../../assets/";

export class AssetConsumingMarker extends React.Component {

  render() {
    const { consumingAsset } = this.props;

    return (
      <div text={ consumingAsset.name ? consumingAsset.name : consumingAsset.city }
      >
        <Tooltip title={ consumingAsset.name ? consumingAsset.name : consumingAsset.city}  >
          <div>
            <Place
              style={{
                color: "#607D8B",
                fontSize: 52,
                position: "absolute",
                top: -40,
                left: -21
              }}
            />
            <img
              src={assets.images.factoryMapIcon2}
              alt="factory_map_icon"
              style={{
                maxHeight: 19,
                marginLeft: 19,
                marginRight: 19,
                marginBottom: -4,
                position: "absolute",
                top: -30,
                left: -23
              }}
            />
          </div>
        </Tooltip>
      </div>
    )
  };
}


// WEBPACK FOOTER //
// ./src/components/MapCards/AssetConsumingMarker.js